import { Product } from "../models/product";
import { httpGet } from "./http-client";

const apiUrl = '/api/products';

export const getProducts = () => httpGet<Product[]>(apiUrl);
